// import { post, fetch }  from "./http";
import * as api from "./api";
import { post } from '@/api/http.js';

// 数据统计－客户分析
export function increase(params) {
  return new Promise((resolve, reject) => {
    post(api.increase, params)
      .then((res) => {
        resolve(res);
      }, err => {
        resolve("失败执行1")
      }).catch(err => {
        console.log(err)
        resolve("失败执行2")
      })
  })
}

// 云客电话记录
export function callList(params) {
  return new Promise((resolve, reject) => {
    post(api.callList, params)
      .then((res) => {
        resolve(res);
      }, err => {
        resolve("失败执行1")
      }).catch(err => {
        console.log(err)
        resolve("失败执行2")
      })
  })
}
// dashboard
export function dashboard(params) {
  return new Promise((resolve, reject) => {
    post(api.dashboard, params)
      .then((res) => {
        resolve(res);
      }, err => {
        resolve("失败执行1")
      }).catch(err => {
        console.log(err)
        resolve("失败执行2")
      })
  })
}
// dashboard
export function wash(params) {
  return new Promise((resolve, reject) => {
    post(api.wash, params)
      .then((res) => {
        resolve(res);
      }, err => {
        resolve("失败执行1")
      }).catch(err => {
        console.log(err)
        resolve("失败执行2")
      })
  })
}
// recommend
export function recommend(params) {
  return new Promise((resolve, reject) => {
    post(api.recommend, params)
      .then((res) => {
        resolve(res);
      }, err => {
        resolve("失败执行1")
      }).catch(err => {
        console.log(err)
        resolve("失败执行2")
      })
  })
}